import isSupport from './isSupport'
import bridge from './bridge'
import callbacks from './callbacks'

import BridgeError from '../utils/BridgeError'
import { checkArgs } from '../utils/checks'

export function callbackAdapter(method, data, callback, spec) {
  if (!isSupport(method)) {
    throw new BridgeError('ERR_NOT_SUPPORT', `not support ${method}`)
  }

  if (spec?.argsT) {
    checkArgs(data, spec.argsT, method)
  }

  let funcName

  if (typeof callback === 'function') {
    funcName = callbacks.add(method, callback, spec)
  }

  bridge(method, data, funcName)
}

export function adapter(method, data, spec) {
  return new Promise((resolve, reject) => {
    try {
      let newData = data
      let newSpec = spec

      if (newData && (newData.argsT || newData.resT)) {
        newSpec = newData
        newData = undefined
      }

      callbackAdapter(method, newData, resolve, newSpec)
    } catch (e) {
      reject(e)
    }
  })
}
